<template>
  <div>
    <v-dialog
      data-testid="create_routine_modal"
      data-tourid="create_routine_modal"
      max-width="493"
      max-height="356"
      scrollable
      :value="show"
      @click:outside="handleClose"
      @keydown.esc="handleClose"
    >
      <SelectTypeStep
        v-if="currentStep === STEPS.SELECTION"
        data-testid="create_routine_selection"
        data-tourid="create_routine_selection"
        @selected="handleTypeSelection"
      />
      <NewRoutineTemplateListStep
        v-if="currentStep === STEPS.LIST"
        @back="handleBack"
        @showChecklist="showChecklist"
      />
    </v-dialog>
    <TemplateDetailsDrawer
      v-if="showTemplateDrawer"
      :visible="showTemplateDrawer"
      :templateRoutine="selectedTemplate"
      @close="showTemplateDrawer = false"
    />
  </div>
</template>

<script>
import mixin from '@/mixins/mixin'
import trackerMixin from '@/mixins/tracking/trackerMixin'

import SelectTypeStep from './SelectTypeStep.vue'
import TemplateDetailsDrawer from './TemplateDetailsDrawer.vue'
import NewRoutineTemplateListStep from './NewRoutineTemplateListStep.vue'

const STEPS = {
  SELECTION: 'selection',
  LIST: 'list',
}

export default {
  name: 'CreateRoutinevModal',

  mixins: [mixin, trackerMixin],

  data() {
    return {
      STEPS,
      currentStep: STEPS.SELECTION,
      showTemplateDrawer: false,
      selectedTemplate: '',
    }
  },

  components: {
    SelectTypeStep,
    NewRoutineTemplateListStep,
    TemplateDetailsDrawer,
  },

  props: {
    show: {
      type: Boolean,
      default() {
        return false
      },
    },
  },

  methods: {
    handleTypeSelection(type) {
      if (type === 'newRoutine') {
        this.trackRoutineViewNavigate({
          source: 'createRoutineModal',
          action: 'goToCreateScreen',
          fromTemplate: false,
        })
        return this.navigateTo({ name: 'createRoutineDefinition' })
      }
      this.currentStep = STEPS.LIST
    },

    handleClose() {
      this.currentStep = STEPS.SELECTION
      this.$emit('close')
    },
    handleBack() {
      this.currentStep = STEPS.SELECTION
    },

    showChecklist(val) {
      this.selectedTemplate = val
      this.showTemplateDrawer = true
    },
  },
}
</script>
